var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.601,
    height: 22.006,
    viewBox: "0 0 34.601 22.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(-1509.122 -7977.483)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6124",
    "data-name": "Line 6124",
    y2: 32.601,
    transform: "translate(1510.122 7988.487) rotate(-90)",
    fill: "none",
    stroke: "#1C1C1C66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M0,0,9.589,9.587,19.178,0",
    transform: "translate(1533.135 7998.075) rotate(-90)",
    fill: "none",
    stroke: "#1C1C1C66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyArrow);
export default __webpack_public_path__ + "static/media/grey-arrow.02766f6b433c8a8fafbb431492ac30d4.svg";
export { ForwardRef as ReactComponent };